import {Base} from "@/api/Base"

export class PaymentDelete extends Base {
    path = "payment/delete"
}